import type { ReactElement } from 'react';
import { PageHeader } from '@/shared/ui';
import { LandingHeroManager } from '@/widgets/landing-hero-manager';

/** 배너 관리 — 고객 web HOME 첫 화면 배너(사진·연결 상품·문구)를 한곳에서 관리한다. */
export const BannersPage = (): ReactElement => (
  <>
    <PageHeader
      title="배너 관리"
      description="고객 web HOME 첫 화면 배너 — 배너 사진, 배너마다 보여 줄 문구와 상품을 정합니다."
    />

    <div className="flex flex-col gap-6">
      <LandingHeroManager />
    </div>
  </>
);
